import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type PremiumAddPaymentModalComponent = EntryPointComponent<
	Record<string, never>,
	Record<string, never>,
	{
		onClose: () => void;
	},
	Record<string, never>
>;

export const entryPoint: EntryPoint<PremiumAddPaymentModalComponent, {}> = createEntryPoint({
	root: JSResourceForInteraction<PremiumAddPaymentModalComponent>(
		/* webpackChunkName: "@atlaskit-internal_edition-awareness-premium-add-payment-modal" */ './premium-add-payment-modal',
		{
			moduleId: 'edition-awareness-premium-add-payment-modal',
		},
	),
	getPreloadProps: () => ({
		entryPoints: {},
		extraProps: {},
		queries: {},
	}),
});
